import st from './index.module.scss';
import { useRef } from 'react';
import LazyLoad from 'react-lazyload';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Head from 'next/head';

const ThankYou = () => {
  const vidRef = useRef(null);
  const vidButtonRefPlay = useRef(null);
  const vidButtonRefPause = useRef(null);

  const settings = {
    centerMode: true,
    centerPadding: '155px',
    slidesToShow: 3,
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
    responsive: [
      {
        breakpoint: 1300,
        arrows: false,
        prevArrow: null,
        nextArrow: null,
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
        },
      },
    ],
  };
  const businessInNumbersSettings = {
    slidesToShow: 6,
    infiniteLoop: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          autoplay: true,
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '75px',
        },
      },
    ],
  };

  function SampleNextArrow(props) {
    const { style, onClick } = props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="24"
        viewBox="0 0 14 24"
        fill="none"
        onClick={onClick}
        id="next"
        style={{ ...style, display: 'block', cursor: 'pointer' }}
      >
        <path d="M0 2.544L9.10231 12L0 21.456L2.44884 24L14 12L2.44884 0L0 2.544Z" fill="#670F7A" />
      </svg>
    );
  }
  function SamplePrevArrow(props) {
    const { style, onClick } = props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="24"
        viewBox="0 0 14 24"
        fill="none"
        onClick={onClick}
        id="prev"
        style={{ ...style, display: 'block', cursor: 'pointer' }}
      >
        <path d="M14 21.456L4.89769 12L14 2.544L11.5512 1.69326e-06L-1.81195e-06 12L11.5512 24L14 21.456Z" fill="#670F7A" />
      </svg>
    );
  }

  const handlePlay = () => {
    vidRef.current.play();
    // hide overlay play button styles, set by 'video__play-button'
    vidButtonRefPlay.current.classList.remove('is-playing');
    vidButtonRefPause.current.classList.add('is-playing');
    vidButtonRefPause.current.classList.remove('flex-first');
    vidButtonRefPlay.current.classList.remove('flex-first');
  };
  const handlePause = () => {
    vidRef.current.pause();
    // show overlay play button styles, set by 'video__play-button'
    vidButtonRefPause.current.classList.remove('is-playing');
    vidButtonRefPause.current.classList.remove('flex-first');
    vidButtonRefPlay.current.classList.remove('flex-first');
    vidButtonRefPlay.current.classList.add('is-playing');
  };
  const handleToggleVideo = () => (vidRef.current.paused ? handlePlay() : handlePause());

  return (
    <>
      <Head>
        <title>Thanks for contacting us - WeProdigi</title>
        <meta name="description" content="" />
        <meta name="robots" content="noindex, nofollow" />
        <meta property="og:image" content="/uploads/images/home-page/meta.png" />
      </Head>
      <div className={`relative w-full min-h-700 h-screen md:h-intro  overflow-hidden ` + st.bg}>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col md:flex-row  justify-center md:justify-between items-center overflow-hidden">
            <div className="w-full md:w-55p">
              <div className="flex items-end text-green font-bold md:font-n-800 text-32 md:text-60 leading-44 md:leading-73 uppercase">
                Thank you
                <img
                  src="https://weprodigi.com/uploads/images/thank-you/thank-you.png"
                  alt=""
                  className={'ml-5 md:ml-15 bounce-in-top w-90 md:w-144'}
                />
              </div>
              <p className="flex items-end text-white font-bold  md:font-bold text-32 md:text-60 leading-44 md:leading-73 uppercase">
                for contacting WeProdigi!
              </p>
              <p className={'text-normal text-white text-16 md:text-18 leading-20 md:leading-22 mt-10'}>
                One of our account managers will contact you and confirm your request. If you don’t receive an email from us within 24 hours please
                check your Spam Box. In the meantime, learn more about what makes us different.
              </p>
            </div>
            <div className="w-full md:w-40p mt-24 md:mt-0">
              <div className={'relative h-234 md:h-330 ' + st.greenBorder}>
                <div className={'overflow-hidden for-hover absolute bottom-0 md:-bottom-1 left-0 md:-left-1 ' + st.border}>
                  <video
                    ref={vidRef}
                    poster={'https://weprodigi.com/uploads/images/thank-you/poster.jpg'}
                    className={'w-auto md:w-full ' + st['header-video']}
                  >
                    <source src="https://weprodigi.com/uploads/images/thank-you/Testimonials_edited.mp4" type="video/mp4" />
                  </video>
                  <div className="btn-part top-0 absolute w-full h-full flex items-center justify-center">
                    <button onClick={handleToggleVideo} ref={vidButtonRefPlay} className={'d-none is-playing flex-first'}>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="white" className="w-6 h-6">
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
                        />
                      </svg>
                    </button>
                    <button onClick={handleToggleVideo} ref={vidButtonRefPause} className={'d-none'}>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="white" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 5.25v13.5m-7.5-13.5v13.5" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LazyLoad height={200} once>
        <div className="bg-gray-light py-24">
          <div className="container">
            <p className={'text-16 leading-24 text-black'}>
              {' '}
              Instead of making promises, we provide proof. Read and watch their testimonials to have complete confidence in choosing us as your
              partner.
            </p>
            <div className="mt-24 flex justify-between">
              <a area-label={'Link'} href="https://clutch.co/profile/weprodigi-agency#reviews" className={'pr-20 md:pr-5'} target={'_blank'}>
                <img src="https://admin.weprodigi.com/uploads/images/testimonals/clutch.svg" width={227} alt="clutch" />
              </a>
              <a
                area-label={'Link'}
                className={'pr-20 md:pr-5'}
                href="https://www.google.com/maps/place/WeProdigi+-+Production+%26+Digital+Marketing+Agency/@40.1997698,44.5105341,17z/data=!4m7!3m6!1s0x406aa3e369ae5ccd:0x601e8f09360c508f!8m2!3d40.1997887!4d44.5105218!9m1!1b1"
                target={'_blank'}
              >
                <img src="https://admin.weprodigi.com/uploads/images/testimonals/google.svg" width={126} alt="google" />
              </a>
              <a className={'pr-20 md:pr-5'} href="https://www.facebook.com/weprodigi/reviews/" target={'_blank'}>
                <img src="https://admin.weprodigi.com/uploads/images/testimonals/facebook.svg" width={153} alt="facebook" />
              </a>
              <a href="https://www.goodfirms.co/company/weprodigi-marketing-agency" target={'_blank'}>
                <img src="/images/goodFirms.svg" width={250} alt="goodfirms" />
              </a>
            </div>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container">
            <div className="title py-10 pt-20 md:pt-10 font-bolder text-24 md:text-48 text-black uppercase">discover our values</div>
            <div className="flex flex-wrap justify-between">
              <div className="w-full md:w-half-auto-2">
                <div className="font-normal text-black text-16 ">
                  We measure our success by long-term relationships, which is why we focus on results that deliver transparency, reliability, and
                  outstanding customer service. The four cornerstones of our advance comprise the customer-oriented and quality-driven approach.
                </div>
                <div className="flex flex-wrap justify-between  mt-30">
                  <a
                    href="/about-us/we-value-time "
                    target={'_blank'}
                    className="h-30 w-full md:w-half-auto flex justify-between items-center border-t-1 box-content border-line py-10 text-gray-slider"
                  >
                    <span className={'text-black'}>We Value Time</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none">
                      <path d="M1 1L8.5 8.5L1 16" stroke="currentColor" strokeLinecap="round" />
                    </svg>
                  </a>
                  <a
                    href="/about-us/we-strive-for-inovations"
                    target={'_blank'}
                    className="h-30 w-full md:w-half-auto flex justify-between items-center border-t-1 box-content border-line py-10 text-gray-slider"
                  >
                    <span className={'text-black'}>We Strive for Innovations</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none">
                      <path d="M1 1L8.5 8.5L1 16" stroke="currentColor" strokeLinecap="round" />
                    </svg>
                  </a>
                  <a
                    href="/about-us/we-value-learning"
                    target={'_blank'}
                    className="h-30 w-full md:w-half-auto flex justify-between items-center border-b-0 border-t-1 md:border-b-1 box-content border-line py-10 text-gray-slider"
                  >
                    <span className={'text-black'}>We Value Learning </span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none">
                      <path d="M1 1L8.5 8.5L1 16" stroke="currentColor" strokeLinecap="round" />
                    </svg>
                  </a>
                  <a
                    href="/about-us/we-corporate-social-responsibility"
                    target={'_blank'}
                    className="h-30 w-full md:w-half-auto flex justify-between items-center border-t-1 border-b-1 box-content border-line py-10 text-gray-slider"
                  >
                    <span className={'text-black'}>We value CSR</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none">
                      <path d="M1 1L8.5 8.5L1 16" stroke="currentColor" strokeLinecap="round" />
                    </svg>
                  </a>
                </div>
              </div>
              <div className="w-full md:w-half-auto-2 pb-23 mt-30 md:mt-0">
                <picture className="">
                  <source srcSet="/images/dif/our_services.webp" type="image/png" />
                  <img src="/images/dif/our_services.webp" alt="discover image" width="541" height="327" />
                </picture>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container">
            <div className="py-30">
              <p className="title first-slider font-bolder text-24 md:text-48 text-black leading-29 uppercase">our business in numbers</p>
              <Slider {...businessInNumbersSettings} className="mt-15">
                <div>
                  <p className={'text-32 text-purple font-bolder'}>2006</p>
                  <p className={'text-14 text-gray-headerIcon font-normal'}>experienced in digital marketing since 2006</p>
                </div>
                <div className={'pl-10'}>
                  <p className={'text-32 text-purple font-bolder'}>$180 mln</p>
                  <p className={'text-14 text-gray-headerIcon font-normal'}>in revenue for our clients</p>
                </div>
                <div className={'pl-10'}>
                  <p className={'text-32 text-purple font-bolder'}>98%</p>
                  <p className={'text-14 text-gray-headerIcon font-normal'}>positive reviews from our costumers</p>
                </div>
                <div className={'pl-10'}>
                  <p className={'text-32 text-purple font-bolder'}>91%</p>
                  <p className={'text-14 text-gray-headerIcon font-normal'}>returning customers</p>
                </div>
                <div className={'pl-10'}>
                  <p className={'text-32 text-purple font-bolder'}>81%</p>
                  <p className={'text-14 text-gray-headerIcon font-normal'}>33 staff members, 81% of them are female:</p>
                </div>
                <div className={'pl-10'}>
                  <p className={'text-32 text-purple font-bolder'}>13</p>
                  <p className={'text-14 text-gray-headerIcon font-normal'}>Partnerships in 13 countries</p>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container">
            <div className="py-30">
              <div className="title font-bolder text-24 md:text-48 text-black leading-29 uppercase">Appearences In Media</div>
              <Slider {...settings} className="mt-15">
                <a href="https://en.168.am/2020/06/04/38006.html" target="_blank" className="h-250 mx-10 p-10">
                  <img src="/images/about/168.webp" alt="168" width={'100%'} height={'80%'} />
                  <div className="text-14 font-bolder text-black">Social Media User First: Strategy for Strong User Engagement</div>
                  <span href="https://en.168.am/2020/06/04/38006.html" target="_blank" className="text-gray-slider text-14">
                    168.am
                  </span>
                </a>
                <a href="https://www.aravot-en.am/2020/07/07/259428/" target="_blank" className="h-250 mx-10 p-10">
                  <img src="/images/about/aravot.webp" alt="aravot" width={'100%'} height={'80%'} />
                  <div className="text-14 font-bolder text-black">Why do we love watching videos so much?</div>
                  <span href="https://www.aravot-en.am/2020/07/07/259428/" target="_blank" className="text-gray-slider text-14">
                    Aravot.am
                  </span>
                </a>
                <a href="https://armenpress.am/eng/news/1023175.html" target="_blank" className=" h-250 mx-10 p-10">
                  <img src="/images/about/Armenpress.webp" alt="Armenpress" width={'100%'} height={'80%'} />
                  <div className="text-14 font-bolder text-black">Armenian businesses record success on international level</div>
                  <span href="https://armenpress.am/eng/news/1023175.html" target="_blank" className="text-gray-slider text-14">
                    Armenpress.am
                  </span>
                </a>
                <a
                  href="https://www.bignewsnetwork.com/news/265623046/prodigi-women-led-businesses-are-possible-in-armenia"
                  target="_blank"
                  className="h-250 mx-10 p-10"
                >
                  <img src="/images/about/bignewsnetwork.webp" alt="bignewsnetwork" width={'100%'} height={'80%'} />
                  <div className="text-14 font-bolder text-black">ProDigi: Women-led businesses are possible in Armenia</div>
                  <span
                    href="https://www.bignewsnetwork.com/news/265623046/prodigi-women-led-businesses-are-possible-in-armenia"
                    target="_blank"
                    className="text-gray-slider text-14"
                  >
                    Bignewsnetwork.com
                  </span>
                </a>
                <a
                  href="https://www.dallassun.com/news/265623046/prodigi-women-led-businesses-are-possible-in-armenia"
                  target="_blank"
                  className=" h-250 mx-10 p-10"
                >
                  <img src="/images/about/Dallassun.webp" alt="Dallassun" width={'100%'} height={'80%'} />
                  <div className="text-14 font-bolder text-black">Women-led businesses are possible in Armenia</div>
                  <span
                    href="https://www.dallassun.com/news/265623046/prodigi-women-led-businesses-are-possible-in-armenia"
                    target="_blank"
                    className="text-gray-slider text-14"
                  >
                    Dallassun.com
                  </span>
                </a>
                <a
                  href="https://www.starterstory.com/how-to-start-a-video-production-digital-marketing-agency"
                  target="_blank"
                  className=" h-250 mx-10 p-10"
                >
                  <img src="/images/about/Panorama.webp" alt="Panorama" width={'100%'} height={'80%'} />
                  <div className="text-14 font-bolder text-black">Covid-19: A bridge for business opportunities</div>
                  <span
                    href="https://www.starterstory.com/how-to-start-a-video-production-digital-marketing-agency"
                    target="_blank"
                    className="text-gray-slider text-14"
                  >
                    Panorama.am
                  </span>
                </a>
                <a href="https://www.panorama.am/en/news/2020/07/15/Covid-19/2328381" target="_blank" className=" h-250 mx-10 p-10">
                  <img src="/images/about/starterstory.webp" alt="starterstory" width={'100%'} height={'80%'} />
                  <div className="text-14 font-bolder text-black">How We Started A $90K/Month Video Production And Digital Marketing Agency</div>
                  <span href="https://www.panorama.am/en/news/2020/07/15/Covid-19/2328381" target="_blank" className="text-gray-slider text-14">
                    Starterstory.com
                  </span>
                </a>
              </Slider>
            </div>
          </div>
        </div>
      </LazyLoad>
      <style global jsx>{`
        .slick-list:first-of-type,
        for-hover:first-of-type {
          padding-left: 0 !important;
        }
        #next {
          position: absolute;
          left: 105%;
          top: 41%;
        }

        #prev {
          position: absolute;
          right: 105%;
          top: 41%;
        }
        .d-none {
          display: none;
          background: #000000ad;
          width: 60px;
          height: 60px;
          border-radius: 50%;
        }
        .is-playing {
          justify-content: center;
          align-items: center;
        }
        .for-hover:hover .is-playing {
          display: flex;
        }
        .flex-first {
          display: flex;
        }

        @-webkit-keyframes bounce-in-top {
          0% {
            -webkit-transform: translateY(-500px);
            transform: translateY(-500px);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
            opacity: 0;
          }
          38% {
            -webkit-transform: translateY(0);
            transform: translateY(0);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
            opacity: 1;
          }
          55% {
            -webkit-transform: translateY(-65px);
            transform: translateY(-65px);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
          }
          72% {
            -webkit-transform: translateY(0);
            transform: translateY(0);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
          }
          81% {
            -webkit-transform: translateY(-28px);
            transform: translateY(-28px);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
          }
          90% {
            -webkit-transform: translateY(0);
            transform: translateY(0);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
          }
          95% {
            -webkit-transform: translateY(-8px);
            transform: translateY(-8px);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
          }
          100% {
            -webkit-transform: translateY(0);
            transform: translateY(0);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
          }
        }
        @keyframes bounce-in-top {
          0% {
            -webkit-transform: translateY(-500px);
            transform: translateY(-500px);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
            opacity: 0;
          }
          38% {
            -webkit-transform: translateY(0);
            transform: translateY(0);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
            opacity: 1;
          }
          55% {
            -webkit-transform: translateY(-65px);
            transform: translateY(-65px);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
          }
          72% {
            -webkit-transform: translateY(0);
            transform: translateY(0);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
          }
          81% {
            -webkit-transform: translateY(-28px);
            transform: translateY(-28px);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
          }
          90% {
            -webkit-transform: translateY(0);
            transform: translateY(0);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
          }
          95% {
            -webkit-transform: translateY(-8px);
            transform: translateY(-8px);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
          }
          100% {
            -webkit-transform: translateY(0);
            transform: translateY(0);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
          }
        }
        .bounce-in-top {
          -webkit-animation: bounce-in-top 1.1s both;
          animation: bounce-in-top 1.1s both;
        }
      `}</style>
    </>
  );
};
export default ThankYou;
